import React from 'react';
import { Link } from 'gatsby';

export default function SurlryBlokLink({
  to, noFollow, children, ...props
}) {
  const url = to.trim();
  // Check if the URL starts with a hash (#).
  if (url.startsWith('#')) {
    return (
      <a
        href={url}
        {...props}
      >
        {children}
      </a>
    );
  }
  // Check if the URL starts with http, https, or www.
  const isExternal = url.startsWith('http://')
                    || url.startsWith('https://')
                    || url.startsWith('www.')
                    || url.startsWith('//');

  if (!isExternal) {
    const link = url.startsWith('/') ? url : `/${url}`;
    return (
      <Link
        to={link}
        {...props}
      >
        {children}
      </Link>
    );
  }

  // Ensure the URL has a proper prourlcol
  const href = url.startsWith('www.') ? `https://${url}` : url;

  return (
    <a
      href={href}
      target="_blank"
      rel={`noreferrer ${noFollow ? 'nofollow' : ''}`.trim()}
      {...props}
    >
      {children}
    </a>
  );
}
